import React from 'react';
import { Backdrop, CircularProgress } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";

function BackDropLoading({ loading }) {
  return (
    <Backdrop open={loading} className="backDropLoading2">
      <div className="d-flex flex-column justify-content-center">
        <CircularProgress color="inherit" size={50} thickness={4} />
        <Translator id={'pleaseWait'} />
      </div>
    </Backdrop>
  );
}

export default BackDropLoading;
